// extracted by mini-css-extract-plugin
export default {"root":"root--QwUDK","options":"options--oWgAh","content":"content--IIyfv","header":"header--hUlXY"};